import type { QueryClient } from '@tanstack/react-query';
import type { PaymentOptionsResponse } from '@app/shared';
import { api } from './api';

/** The packs on sale right now: the «Купить» block of «Кредиты» and the build panel share it. */
export const paymentOptionsQuery = {
  queryKey: ['payment-options'] as const,
  queryFn: (): Promise<PaymentOptionsResponse> => api.getPaymentOptions(),
  staleTime: 60_000,
};

/** Asked only when credits ran out: is anything on sale? With every method off — no. */
export async function canBuyNow(qc: QueryClient): Promise<boolean> {
  try {
    return (await qc.fetchQuery(paymentOptionsQuery)).packs.length > 0;
  } catch {
    return false;
  }
}
